import { useCallback, useMemo } from 'react'

import _ from 'lodash'
import { useSelector } from 'react-redux'
import { productState } from 'Config/constants'

const useApproveOrderMin = () => {
  const cart = useSelector(state => state.approver.cart)

  const [okProducts] = _.map(cart)?.reduce(
    ([ok, notOk], elem) => (elem.state === productState.noAvailable ? [ok, [...notOk, elem]] : [[...ok, elem], notOk]),
    [[], []]
  )

  const productsToShow = _.groupBy(okProducts, 'provider.name')

  const totalByProvider = useMemo(
    () =>
      _(okProducts)
        .groupBy('provider.name')
        .map((item, key) => ({
          index: key,
          total: _.sumBy(item, 'total'),
        }))
        .value(),
    [okProducts]
  )
  const minOrderByProvider = useMemo(() => {
    const providerMap = okProducts.reduce((acc, { provider }) => {
      acc[provider.name] = { orderMinimum: provider?.orderMinimum || null }
      return acc
    }, {})
    return providerMap
  }, [okProducts])

  const notMin = useMemo(() => {
    const result = Object.entries(minOrderByProvider).reduce((acc, [provider, data]) => {
      const totalItem = totalByProvider.find(tP => tP.index === provider)
      const total = totalItem?.total ?? 0
      const { orderMinimum } = data
      if (orderMinimum != null && orderMinimum - total > 0) {
        acc[provider] = {
          ...data,
          needsMore: orderMinimum - total,
        }
      }
      return acc
    }, {})
    return Object.keys(result)?.length > 0
  }, [minOrderByProvider, totalByProvider])

  const hastToShowErrorMinOrder = useMemo(() => {
    if (notMin) {
      return true
    }
    return false
  }, [notMin])

  const getIfNeedMinByProvider = useCallback(
    prov =>
      minOrderByProvider[prov]?.orderMinimum &&
      minOrderByProvider[prov]?.orderMinimum - totalByProvider.find(element => element.index === prov).total > 0,
    [minOrderByProvider, totalByProvider]
  )

  return {
    notMin,
    minOrderByProvider,
    totalByProvider,
    productsToShow,
    hastToShowErrorMinOrder,
    getIfNeedMinByProvider,
  }
}

export default useApproveOrderMin
